// extracted by mini-css-extract-plugin
export var change = "_3e-1";
export var changeList = "_3e-0";
export var changePath = "_3e-2";
export var diffArrow = "_3e-5";
export var diffRow = "_3e-3";
export var diffValue = "_3e-4";
export var error = "_3e-8";
export var notice = "_3e-9";
export var result = "_3e-6";
export var success = "_3e-7";